/**
 * @file Album Folder Purchase Uniform Tag Modal Container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import produce from 'immer';

import AlbumFolderPurchaseUniformTagModal from '../../../components/purchase/album-folder-purchase/AlbumFolderPurchaseUniformTagModal';
import { selectTag, updatedTag } from '../../../actions/identity-tag-selection';
import { openModal, closeModal } from '../../../actions/modal-actions';
import { identityAlbumFolderTagUpdate } from '../../../graphql/mutations/album-folder-tags';
import { MeWithIdentitiesWithTags } from '../../../graphql/queries/account';

const mapDispatchToProps = {
  selectTag,
  openModal,
  closeModal,
  updatedTag,
};

const withIdentityAlbumFolderTagUpdate = graphql(identityAlbumFolderTagUpdate, {
  props: ({ ownProps, mutate }) => ({
    identityAlbumFolderTagUpdate: (identityTag, metadata, identityId) =>
      mutate({
        variables: {
          input: {
            id: identityTag.id,
            uniform: {
              uniform_album_folder_tag_level_id: metadata.levelId,
              jersey_number: metadata.jerseyNumber,
              uniform_album_folder_tag_level_team_id: metadata.teamId,
            },
          },
        },
        optimisticResponse: {
          __typename: 'Mutation',
          identityAlbumFolderTagUpdate: {
            __typename: 'IdentityAlbumFolderTagUpdatePayload',
            identity_album_folder_tag: {
              ...identityTag,
              id: identityTag.id,
            },
          },
        },
        update: (
          store,
          {
            data: {
              identityAlbumFolderTagUpdate: { identity_album_folder_tag: tag },
            },
          },
        ) => {
          const { match } = ownProps;

          const data = store.readQuery({
            query: MeWithIdentitiesWithTags,
            variables: {
              albumFolderId: match.params.albumFolderId,
              albumFolderIds: [match.params.albumFolderId],
            },
          });

          const updatedData = produce(data, draft => {
            draft.me.linked_identities.records = data.me.linked_identities.records.map(
              identity => {
                if (identity.id !== identityId) {
                  return identity;
                }

                return {
                  ...identity,
                  album_folder_tags: {
                    ...identity.album_folder_tags,
                    records: identity.album_folder_tags.records.map(
                      identityTagItem => {
                        if (identityTagItem.id !== tag.id) {
                          return identityTagItem;
                        }

                        return tag;
                      },
                    ),
                  },
                };
              },
            );
          });

          store.writeQuery({
            query: MeWithIdentitiesWithTags,
            variables: {
              albumFolderId: match.params.albumFolderId,
              albumFolderIds: [match.params.albumFolderId],
            },
            data: updatedData,
          });
        },
      }),
  }),
});

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withIdentityAlbumFolderTagUpdate,
)(AlbumFolderPurchaseUniformTagModal);
